import { Link } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { LogoFull } from "@/components/Logo";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-ink2">
    <div className="mx-auto max-w-7xl px-5 py-14 md:px-12">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <LogoFull />
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            Artículos, crónicas y análisis del Sporting de Gijón y del fútbol en general.
            Desde la grada, con corazón rojiblanco.
          </p>
        </div>
        <div className="flex gap-14">
          <div>
            <p className="eyebrow mb-4">Secciones</p>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li><Link to="/articulos" className="hover:text-crimson">Artículos</Link></li>
              <li><Link to="/cronicas" className="hover:text-crimson">Crónicas</Link></li>
              <li><Link to="/sobre" className="hover:text-crimson">Sobre ENOLFC</Link></li>
              <li><Link to="/contacto" className="hover:text-crimson">Contacto</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow mb-4">Sígueme</p>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li>
                <a href="https://www.tiktok.com/@enolfc" target="_blank" rel="noopener noreferrer" className="hover:text-crimson" data-testid="footer-tiktok-link">
                  TikTok · @ENOLFC
                </a>
              </li>
              <li>
                <Link to="/contacto" className="flex items-center gap-1.5 hover:text-crimson">
                  <Mail className="h-3.5 w-3.5" /> Escríbeme
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono-score text-xs uppercase tracking-widest text-slate-500">
          © 2026 ENOLFC · Hecho con pasión rojiblanca
        </p>
        <Link
          to="/admin"
          data-testid="footer-admin-link"
          className="flex items-center gap-1.5 font-mono-score text-xs uppercase tracking-widest text-slate-600 transition-colors hover:text-crimson"
        >
          <Lock className="h-3 w-3" /> Admin
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
